export function MiniDivider() {
  return <div className="border-t border-border-subtle" />;
}
